(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cloud-pbx', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/cloud-pbx?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.cloudPBX.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cloud-pbx/cloud-pbxes.html',
                    controller: 'CloudPBXController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cloudPBX');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cloud-pbx-detail', {
            parent: 'cloud-pbx',
            url: '/cloud-pbx/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.cloudPBX.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cloud-pbx/cloud-pbx-detail.html',
                    controller: 'CloudPBXDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cloudPBX');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CloudPBX', function($stateParams, CloudPBX) {
                    return CloudPBX.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'cloud-pbx',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('cloud-pbx-detail.edit', {
            parent: 'cloud-pbx-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cloud-pbx/cloud-pbx-dialog.html',
                    controller: 'CloudPBXDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CloudPBX', function(CloudPBX) {
                            return CloudPBX.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cloud-pbx.new', {
            parent: 'cloud-pbx',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cloud-pbx/cloud-pbx-dialog.html',
                    controller: 'CloudPBXDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                caption: null,
                                url: null,
                                attendantDuration: null,
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cloud-pbx', null, { reload: 'cloud-pbx' });
                }, function() {
                    $state.go('cloud-pbx');
                });
            }]
        })
        .state('cloud-pbx.edit', {
            parent: 'cloud-pbx',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cloud-pbx/cloud-pbx-dialog.html',
                    controller: 'CloudPBXDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CloudPBX', function(CloudPBX) {
                            return CloudPBX.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cloud-pbx', null, { reload: 'cloud-pbx' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cloud-pbx.delete', {
            parent: 'cloud-pbx',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cloud-pbx/cloud-pbx-delete-dialog.html',
                    controller: 'CloudPBXDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CloudPBX', function(CloudPBX) {
                            return CloudPBX.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cloud-pbx', null, { reload: 'cloud-pbx' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
